import { BoardContainer } from "../BoardContainer";
import { Orb } from "./Orb";
import * as Candy from "@ravalmatic/candy-engine";

export class OrbsPool {

    public static id: number;

    private orbs: Orb [];
    private scene: Phaser.Scene;
    private boardContainer: BoardContainer;

    constructor(scene: Phaser.Scene, boardContainer: BoardContainer, numOrbs: number) {

        OrbsPool.id = 0;

        this.scene = scene;
        this.boardContainer = boardContainer;
        this.orbs = [];

        for (let i = 0; i < numOrbs; i++) {
            
            const orb = new Orb(this.scene, this.boardContainer);
            this.orbs.push(orb);
        }
    }

    public getOrb(orbData: Candy.OrbData, p: {c: number, r: number}): Orb {

        if (this.orbs.length === 0) {
            this.increasePoolSize();
        }

        OrbsPool.id ++;

        const orb = this.orbs.pop();
        orb.reset(orbData, p);
        
        return orb;
    }

    public onOrbRemovedFromBoard(orb: Orb): void {

        this.orbs.push(orb);
    }

    private increasePoolSize(): void {

        for (let i = 0; i < 10; i ++) {
            const orb = new Orb(this.scene, this.boardContainer);
            this.orbs.push(orb);
        }
    }
}
